import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: "16px !important",
      overflow: "hidden",
      maxWidth: "900px !important",
      width: "900px",
      backgroundColor: "#ffffff",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: "#1a1a1a",
      color: "#fff",
      padding: "20px 28px",
    },
    "& .MuiDialogContent-root": {
      padding: "32px 28px",
    },
    "& .MuiDialogActions-root": {
      padding: "20px 28px",
      borderTop: "1px solid #f1f5f9",
      backgroundColor: "#ffffff",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff !important",
    fontWeight: "700 !important",
    fontSize: "18px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  closeIcon: {
    color: "#fff",
  },
  driverContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    fontFamily: "'Inter', sans-serif",
  },
  driverHeader: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
    paddingBottom: "24px",
    borderBottom: "1px solid #f1f5f9",
  },
  profileImage: {
    width: "96px",
    height: "96px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #f1f5f9",
  },
  headerInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  driverNameText: {
    fontSize: "20px !important",
    fontWeight: "700 !important",
    color: "#0f172a",
  },
  driverRoleText: {
    fontSize: "14px !important",
    color: "#64748b",
  },
  detailsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  sectionHeader: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
    color: "#0f172a",
    margin: "0 !important",
    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "8px",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px 32px",
  },
  keyValue: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  key: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#64748b",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "8px",
  },
  tableHeader: {
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #f1f5f9",
  },
  tableHeaderCell: {
    padding: "12px 16px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#475569",
    textTransform: "uppercase",
    textAlign: "left",
  },
  tableRow: {
    borderBottom: "1px solid #f1f5f9",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tableCell: {
    padding: "14px 16px",
    fontSize: "14px",
    color: "#334155",
  },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    width: "100%",
  },
  closeBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#ffffff",
      textTransform: "none",
      color: "#374151",
      borderRadius: 8,
      padding: "10px 24px",
      border: "1px solid #e5e7eb",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      "&:hover": {
        backgroundColor: "#f9fafb",
      },
    },
  },
  confirmBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#1a1a1a",
      textTransform: "none",
      color: "#ffffff",
      borderRadius: 8,
      padding: "10px 24px",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      "&:hover": {
        backgroundColor: "#333333",
      },
    },
  },
}));

export default useStyles;
